import { render, staticRenderFns } from "./vanTabs.vue?vue&type=template&id=aac66828&scoped=true"
import script from "./vanTabs.vue?vue&type=script&lang=ts"
export * from "./vanTabs.vue?vue&type=script&lang=ts"
import style0 from "./vanTabs.vue?vue&type=style&index=0&id=aac66828&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac66828",
  null
  
)

export default component.exports